(function Index($, Adzuki)
{
	"use strict";

	var $modal = $('.modal');

	Adzuki.onload('LivePlanner/library', function onload() {
		$('.lp-show-folders').click(function _openFolderUI(e) {
			var lp_bucket_item_id = $(this).data('lp-bucket-item-id');

			e.preventDefault();

			Adzuki.Ajax.get('/LivePlanner/addToFolder/' + lp_bucket_item_id)
			.then(function _folders(content) {

				$modal.find('.modal-title').text("Add to LivePlanner Library Folders");
				$modal.find('.modal-body').html(content);

				Adzuki.Form.initAjaxForm('LivePlannerAssignFolder');

				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		});

		$('.lp-library-check').click(function _checkUncheckAll(e) {
			var state = $(this).data('state'),
				$obj  = $(this);

			e.preventDefault();

			if (state === 'unchecked') {
				$('.item-checkboxes').each(function _takeItToTheMaxx() {
					$(this).prop('checked', true);
				});

				$obj.data('state', 'checked');
			} else {
				$('.item-checkboxes').each(function _takeItToTheMaxx() {
					$(this).prop('checked', false);
				});

				$obj.data('state', 'unchecked');
			}
		});

		$('.lp-move-selected').click(function _preSelected(e) {
			var selected = [];

			e.preventDefault();

			$('.item-checkboxes').each(function _getSelected() {
				if ($(this).prop('checked') === true) {
					selected.push($(this).val());
				}
			});

			if (selected.length === 0) {
				Adzuki.StatusMessage("error", "Please select at least one item to move.");
			} else {
				Adzuki.Ajax.post('/LivePlanner/addMultipleToFolder/', {selected: selected})
				.then(function success(content) {
					$modal.find('.modal-title').text("Add to LivePlanner Library Folders");
					$modal.find('.modal-body').html(content);

					Adzuki.Form.initAjaxForm('LivePlannerAssignFolder');

					$modal.on('hidden.bs.modal', function _restoreModal() {
						$modal.removeClass('wide').off('hidden.bs.modal');
					}).modal('show');
				});
			}
		});

		$('.lp-delete-selected').click(function _deleteSelected(e) {
			var selected = [];

			e.preventDefault();

			$('.item-checkboxes').each(function _getSelected() {
				if ($(this).prop('checked') === true) {
					selected.push($(this).val());
				}
			});

			if (selected.length === 0) {
				Adzuki.StatusMessage("error", "Please select at least one item to delete.");
			} else {
				Adzuki.CustomConfirm({
					title  : 'Decision Time',
					content: 'Are you sure you want to delete the selected items?',
					confirm: function confirm() {
						Adzuki.Ajax.post('/LivePlanner/deleteSelectedLibraryItems/', {selected: selected})
						.then(function success(content) {
							if (content.saved === 'true') {
								document.location = Adzuki.base_uri + '/LivePlanner/library';
							} else {
								Adzuki.StatusMessage('error', 'Unable to delete items');
							}
						});
					}
				});
			}
		});
	});
}(jQuery, window.Adzuki || {}));